<template>
    <div class="mapVue-wrapper">
        <div class="options-block">
            <div class="container">
                <h3>подбор сто в вашем городе</h3>
                <div class="wrap">
                    <treeselect
                        v-model="selectedCity"
                        :options="cityList"
                        openDirection="bottom"
                        placeholder="Введите город"
                        valueFormat="object"
                    />
                    <button class="btn" @click="hideOptions = !hideOptions">
                        Выбрать опции
                    </button>
                    <div
                        class="options-selected-list"
                        :class="{ active: hideOptions }"
                    >
                        <p>Опции автосервиса</p>
                        <div
                            class="list-wrapper"
                            :class="{ activeOption: activeOption }"
                        >
                            <ul
                                v-for="(item, key) in getFixedTitles"
                                :key="`${key}_list`"
                            >
                                <li
                                    v-for="(el, index) in item"
                                    :key="`${index}_item`"
                                >
                                    <label>
                                        <input
                                            type="checkbox"
                                            :name="el.id"
                                            v-model="selectedOptionsName"
                                            v-bind:value="el.id"
                                        />
                                        <span>
                                            <svg
                                                width="14"
                                                height="15"
                                                viewBox="0 0 14 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M1.5 7.5L6 12.5L13 1"
                                                    stroke="#E52E2E"
                                                    stroke-width="2"
                                                    stroke-linecap="round"
                                                />
                                            </svg>
                                        </span>
                                        <span class="label">{{
                                            el.label
                                        }}</span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <button
                            class="showOptionsList"
                            :class="{ active: activeOption }"
                            @click="activeOption = !activeOption"
                        >
                            {{
                                !activeOption ? "Больше опций" : "Скрыть опции"
                            }}
                            <span></span>
                        </button>
                    </div>
                    <div class="stations-list-wrapper" v-if="selectedCity">
                        <p>Список СТО</p>
                        <ul class="stations-list">
                            <li
                                v-for="(item, key) in availableCoords"
                                :key="`${key}_item`"
                                @click="check(item)"
                                :class="{
                                    active: item === selectedServiceStation,
                                }"
                            >
                                <div class="stations-name">
                                    <p>{{ item.label }}</p>
                                </div>
                                <div class="stations-address">
                                    {{ item.contacts }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="result-block">
            <div class="STO">
                <div class="STO__wrapper" v-if="selectedServiceStation">
                    <h3
                        v-html="
                            `СТО &quot;${selectedServiceStation.name}&quot;`
                        "
                    />
                    <div class="STO__slider">
                        <button
                            class="prev"
                            @click="$refs.mySlider.goToPrev()"
                        />
                        <agile
                            v-if="selectedServiceStation.images.length"
                            ref="mySlider"
                            :options="sliderOptions"
                            :key="selectedServiceStation.id"
                        >
                            <div
                                class="slide"
                                v-for="(
                                    img, key
                                ) in selectedServiceStation.images"
                                :key="`image_${key}`"
                            >
                                <figure><img :src="img" alt="img" /></figure>
                            </div>
                        </agile>
                        <button
                            class="next"
                            @click="$refs.mySlider.goToNext()"
                        />
                    </div>
                    <ul class="STO__info">
                        <li
                            v-if="selectedServiceStation.contacts"
                            class="STO__contacts"
                        >
                            <span>Контакты</span>
                            <p>{{ selectedServiceStation.contacts }}</p>
                        </li>
                        <li
                            v-if="selectedServiceStation.workTime[0]"
                            class="STO__work-time"
                        >
                            <span>Режим работы</span>
                            <div
                                v-for="(
                                    time, key
                                ) in selectedServiceStation.workTime"
                                :key="`workTime_${key}`"
                            >
                                {{ time }}
                            </div>
                        </li>
                        <li v-if="selectedServiceStation" class="STO__options">
                            <button
                                ref="optionsList"
                                @click="showOptionsList = !showOptionsList"
                            >
                                опции
                            </button>
                            <ul class="options-list" v-show="showOptionsList">
                                <li
                                    v-for="(
                                        item, key
                                    ) in getOptionsForSelectedStation"
                                    :key="`option_${key}`"
                                    v-html="item"
                                />
                            </ul>
                        </li>
                        <li v-if="selectedServiceStation.mail">
                            <span>E - mail</span>
                            <a
                                :href="`mailto:${selectedServiceStation.mail}`"
                                >{{ selectedServiceStation.mail }}</a
                            >
                        </li>
                        <li v-if="selectedServiceStation.tel[0]">
                            <span>Телефон</span>
                            <a
                                v-for="(
                                    tel, index
                                ) in selectedServiceStation.tel"
                                :key="`tel_${index}`"
                                :href="`tel:${tel.replace(' ', '')}`"
                                v-html="tel"
                            />
                        </li>
                        <li v-if="selectedServiceStation.site">
                            <span
                                ><a :href="selectedServiceStation.site"
                                    >САЙТ</a
                                ></span
                            >
                        </li>
                        <li class="STO__map-button">
                            <button @click="hideMap = !hideMap">Карта</button>
                        </li>
                    </ul>
                </div>
            </div>
            <yandex-map
                :class="{ hideMap: !hideMap }"
                id="map"
                ref="map"
                :key="mapRendererKey"
                :settings="settings"
                :zoom="selectedCity ? 17 : 13"
                :coords="getMapCenter"
                style="width: 100%"
                :scroll-zoom="false"
            >
                <ymap-marker
                    v-for="coord in getCoords"
                    :key="`marker_${coord.id}_${mapRendererKey}`"
                    :coords="[coord.lat, coord.lng]"
                    :marker-id="`marker_${coord.id}_${mapRendererKey}`"
                    @click="selectServiceStation(coord)"
                    :icon="{
                        layout: 'default#image',
                        imageHref: `/wp-content/themes/shatemdisel/assets/images/checkmark-${coord.type}.png`,
                        imageSize: setPlacemarkImage(coord),
                        imageOffset: [-22, -55],
                    }"
                />
            </yandex-map>
        </div>
    </div>
</template>
<script>
import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
    components: { yandexMap, ymapMarker },
    props: {
        activeStation: String,
    },
    data: () => {
        return {
            value: null,
            settings: {
                lang: "ru_RU",
                coordorder: "latlong",
                version: "2.1",
            },
            cityList: [],
            hideOptions: false,
            selectedCity: null,
            oldSelectedCity: null,
            selectedOptionsName: [],
            selectedServiceStation: null,
            optionsNameList: [],
            optionsStatusList: [],
            serviceStationList: [],
            availableCoords: [],
            mapRendererKey: 1,
            sliderOptions: {
                fade: true,
                infinite: true,
                slidesToShow: 1,
                navButtons: false,
                dots: false,
            },
            template: {
                contacts:
                    "Минская обл., Минский р-он, Луговослободской с/с, пос. Привольный, ул. Мира, 2А.",
                mail: "info@shate-m.com",
                workTime: ["ПН - ПТ 8:00 - 20:00", "СБ - ВС 9:00 - 19:00"],
                tel: ["505-8-505", "6600", "(017) 500-66-00"],
                site: "https://google.com",
            },
            showOptionsList: false,
            activeOption: false,
            hideMap: false,
        };
    },
    created() {
        var vm = this;

        document.addEventListener("click", function (e) {
            if (
                vm.$refs.optionsList !== e.target &&
                $(".options-list").has(e.target).length === 0
            ) {
                vm.showOptionsList = false;
            }
        });
    },
    async mounted() {
        await this.$store.dispatch("setFromGoogleDocs").then(() => {
            this.cityNormalizer();
        });
        if (this.activeStation) {
            this.selectedServiceStation = this.getGoogleList.find(
                (item) => item.id === this.activeStation
            );
        } else {
            this.selectedServiceStation = this.getGoogleList[0];
        }
    },
    watch: {
        hideOptions() {
            if (this.hideOptions) {
                document.querySelector("body").style.overflow = "hidden";
            } else {
                document.querySelector("body").style.overflow = "";
            }
        },
    },
    methods: {
        check(item) {
            this.selectedServiceStation = item;
        },
        cityNormalizer() {
            let uniqueSet = new Set(
                this.getGoogleList.map((item) => {
                    return item.city;
                })
            );
            this.cityList = Array.from(uniqueSet).map((item, key) => {
                return {
                    id: item,
                    label: item,
                };
            });
        },
        selectServiceStation(item) {
            this.selectedServiceStation = item;
        },
        setPlacemarkImage(item) {
            return this.selectedServiceStation &&
                this.selectedServiceStation.id === item.id
                ? [55, 65]
                : [43, 55];
        },
    },
    computed: {
        getGoogleList() {
            return this.$store.getters["getGoogleList"];
        },
        getFixedTitles() {
            let _ = [];
            this.$store.getters["getFixedTitles"].map((item, index) => {
                if (index % 12 === 0) {
                    _.push([]);
                }
                _[_.length - 1].push(item);
            });
            return _;
        },
        getCoords() {
            this.availableCoords = this.getGoogleList;
            if (this.selectedOptionsName.length) {
                this.selectedOptionsName.map((el) => {
                    this.availableCoords = this.availableCoords.filter(
                        (item) => {
                            if (item[el]) {
                                return el;
                            }
                        }
                    );
                });
            }
            if (this.selectedCity) {
                this.availableCoords = this.availableCoords.filter((item) => {
                    return item.city === this.selectedCity.label;
                });
                // console.log(this.selectedCity !== this.oldSelectedCity);
                if (this.selectedCity !== this.oldSelectedCity) {
                    this.selectedServiceStation = this.availableCoords[0];
                    this.oldSelectedCity = this.selectedCity;
                }
            }

            this.mapRendererKey++;

            return this.availableCoords.filter((item) => item.lat && item.lng);
        },
        getMapCenter() {
            if (this.getGoogleList.length) {
                if (this.availableCoords.length) {
                    if (this.selectedServiceStation) {
                        return [
                            this.selectedServiceStation.lat,
                            this.selectedServiceStation.lng,
                        ];
                    } else {
                        return [
                            this.availableCoords[0].lat,
                            this.availableCoords[0].lng,
                        ];
                    }
                } else {
                    return [
                        this.getGoogleList[0].lat,
                        this.getGoogleList[0].lng,
                    ];
                }
            }
        },
        getOptionsForSelectedStation() {
            return this.getFixedTitles
                .flat()
                .map((item) => {
                    if (this.selectedServiceStation[item.id] === 1) {
                        return item.label;
                    }
                })
                .filter((item) => item);
        },
    },
    watch: {
        selectedCity: function () {
            if (this.selectedCity) {
                this.serviceStationList = this.availableCoords.filter(
                    (item) => {
                        if (item.city === this.selectedCity.label) {
                            return item;
                        }
                    }
                );
            } else {
                this.serviceStationList = this.getGoogleList;
            }
        },
        selectedServiceStation: function () {
            this.mapRendererKey++;
        },
    },
};
</script>
<style lang="scss">
.mapVue-wrapper {
    background: #1c2122;
    .wrap {
        max-width: 1200px;
        margin: 50px auto 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        & > button {
            max-width: 290px;
            border: none;
            outline: none;
            font-size: 15px;
            border: 1px solid;
            background: transparent;
            transition: 0.3s ease-in;
            font-weight: bold;

            @media screen and (min-width: 1200px) {
                &.btn:hover {
                    background: transparent;
                    color: #fff !important;
                    border-color: #fff !important;
                }
            }
            //@media screen and (max-width: 950px) {
            //    display: none;
            //}
        }

        .vue-treeselect {
            width: 100%;
            border: 1px #cecece solid;
            border-left: 3px solid;
            max-width: 550px;
            margin: 0 auto 60px;
            @media screen and (max-width: 767px) {
                margin: 0 0 50px;
            }
            &__control {
                padding-left: 20px;
                height: 70px;
                border: none;
                border-radius: 0;
            }
            &__input-container {
                padding-left: 0;
            }
            &__single-value,
            &__placeholder {
                padding: 18px 0;
                font-size: 16px;

                border: none;
            }
            &__input {
                cursor: pointer;
            }
            &.disable {
                border-left: 3px #c28d8d solid !important;
                pointer-events: none;
            }
            &__multi-value-item-container {
                display: none;
            }
        }
    }
    .options-selected-list {
        z-index: 5;
        height: 100%;
        max-height: 0px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        width: 100%;
        transition: 0.6s linear;
        padding-left: 20px;
        padding-right: 20px;
        @media screen and (max-width: 950px) {
            //max-height: 1500px;
            margin-top: 60px;
        }
        @media screen and (max-width: 767px) {
            //max-height: none;
            margin-top: 30px;
        }

        &.active {
            max-height: 2000px;
            margin-top: 60px;
        }
        & > p {
            font-weight: bold;
            font-size: 30px;
            line-height: 131.9%;
            margin-bottom: 30px;
            color: #fff;
            text-align: center;
        }
        .showOptionsList {
            display: none;
            @media screen and (max-width: 767px) {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 25px;
                max-width: 290px;
                width: 100%;
                padding: 7px;
                border: 1px solid;
                border-color: #fff !important;
                font-weight: bold;
                font-size: 15px;
                line-height: 1.7;
                color: #ffffff !important;
                background: transparent;
                transition: 0.3s linear;
            }
            &.active {
                span {
                    transform: translateY(25%) rotate(-135deg);
                }
            }
            span {
                margin-left: 10px;
                width: 12px;
                height: 12px;
                border-right: 2px solid #fff;
                border-bottom: 2px solid #fff;
                transform: translateY(-25%) rotate(45deg);
                transition: 0.3s linear;
            }
        }
        .list-wrapper {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 3px;
            width: 100%;
            padding: 60px 45px;
            @media screen and (max-width: 950px) {
                padding: 30px 20px;
            }
            @media screen and (max-width: 767px) {
                background: transparent;
                max-height: 347px;
                transition: 0.6s;
                overflow: hidden;
                padding: 0;
                &.activeOption {
                    max-height: 2000px;
                }
            }
        }
        ul {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: 30px;
            grid-template-rows: auto;
            height: 100%;
            width: 100%;
            z-index: 2;
            margin-bottom: 60px;
            @media screen and (max-width: 950px) {
                grid-template-columns: repeat(2, 1fr);
            }
            @media screen and (max-width: 767px) {
                grid-template-columns: auto;
                margin-bottom: 0;
            }
            &:last-of-type {
                margin-bottom: 0;
            }
            li {
                width: 100%;
                margin: 10px 5px;
                @media screen and (max-width: 767px) {
                    margin: 10px 0;
                }
                label {
                    display: flex;
                    position: relative;

                    span.label {
                        font-size: 15px;
                        line-height: 1.3;
                        color: #fff;
                        &::first-letter {
                            text-transform: uppercase;
                        }
                    }
                    input + span{
                        position: relative;
                        min-width: 16px;
                        height: 16px;
                        background: #fff;
                        margin-right: 10px;
                        margin-top: 3px;
                        svg{
                            display: none;
                        }
                    }
                    input:checked + span{
                        svg{
                            display: block;
                        }
                    }
                }
            }
        }
        input {
            appearance: none;
            opacity: 0;
            display: block;
            margin-right: 8px;
            min-width: 16px;
            height: 16px;
        }
    }
    .open-selected-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 180px;
        outline: none;
        border: none;
        background: #ed0b0e;
        border-radius: 10px;
        padding: 20px 10px;
        z-index: 100;
        color: #fff;
        font-weight: 500;
        margin-top: 20px;
    }
    .options-block {
        padding: 100px 0;
        position: relative;
        z-index: 6;
        @media screen and (max-width: 767px) {
            padding: 50px 0;
        }
        h3 {
            font-weight: bold;
            font-size: 25px;
            line-height: 131.9%;
            text-align: center;
            text-transform: uppercase;
            color: #ffffff;
        }
    }
    .stations-list-wrapper {
        margin: 60px 0 30px;
        max-width: 875px;
        width: 100%;
        padding: 0 15px;
        & > p {
            font-weight: bold;
            font-size: 30px;
            line-height: 131.9%;
            margin-bottom: 30px;
            color: #fff;
            text-align: center;
        }
    }
    .stations-list {
        display: flex;
        flex-direction: column;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 3px;
        padding: 20px 30px;
        max-height: 500px;
        overflow: auto;
        width: 100%;
        &::-webkit-scrollbar {
            width: 8px;
            background: #c4c4c4;
            border-radius: 5px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 5px;
        }
        @media screen and (max-width: 767px) {
            padding: 20px 0;
            background: transparent;
        }
        li {
            padding: 20px 40px;
            border-bottom: 1px solid #fff;
            transition: 0.3s ease-in;
            cursor: pointer;
            @media screen and (max-width: 767px) {
                padding: 20px 5px;
                background: transparent;
            }
            @media screen and (min-width: 1200px) {
                &:hover {
                    background: rgba(255, 255, 255, 0.1);
                }
            }
            &:last-of-type {
                border: none;
            }
            &.active {
                background: rgba(255, 255, 255, 0.2);
            }
        }
    }
    .stations-name {
        p {
            font-weight: bold;
            font-size: 18px;
            line-height: 1.6;
            color: #ffffff;
            margin-bottom: 5px;
        }
    }
    .stations-address {
        font-weight: normal;
        font-size: 15px;
        line-height: 1.6;
        color: #ffffff;
    }

    .result-block {
        display: flex;
        z-index: 5;
        position: relative;
        @media screen and (max-width: 1200px) {
            flex-direction: column;
        }
        .STO {
            padding: 45px 10px;
            max-width: 800px;
            width: 100%;
            min-height: 750px;
            @media screen and (max-width: 1200px) {
                max-width: none;
            }
            &__wrapper {
                max-width: 650px;
                width: 100%;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                h3 {
                    color: #fff;
                    max-width: 520px;
                    margin: 0 auto 20px;
                    width: 100%;
                    font-size: 25px;
                    @media screen and (max-width: 767px) {
                        font-size: 20px;
                        text-align: center;
                    }
                }
            }
            &__slider {
                display: flex;
                align-items: center;
                .agile {
                    width: calc(100% - 60px);
                }

                .agile__slide {
                    figure {
                        width: 100%;
                        max-height: 290px;
                        display: flex;
                        justify-content: center;
                        img {
                            width: auto;
                            height: auto;
                            max-height: 290px;
                            max-width: 650px;
                        }
                    }
                }
            }
            &__info {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                grid-template-rows: repeat(2, 1fr);
                grid-gap: 20px;
                padding: 20px 0;
                @media screen and (max-width: 767px) {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                }
                & > li {
                    position: relative;
                    margin-bottom: 20px;
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    @media screen and (max-width: 767px) {
                        width: 48%;
                    }
                    @media screen and (max-width: 480px) {
                        align-items: flex-start;
                        align-self: flex-start;
                    }
                    & > span,
                    & > button,
                    & > span a {
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 113.4%;
                        text-transform: uppercase;
                        margin-bottom: 10px;
                    }
                    & > button {
                        outline: none;
                        border: none;
                        background: transparent;
                        position: relative;
                        width: min-content;
                        padding: 0;
                        &:before {
                            content: "";
                            position: absolute;
                            right: -20px;
                            top: 40%;
                            width: 10px;
                            height: 10px;
                            transform: translateY(-50%) rotate(45deg);
                            border-right: 2px solid;
                            border-bottom: 2px solid;
                        }
                    }
                    & > p,
                    & > div,
                    & > a {
                        font-size: 15px;
                        line-height: 153.5%;
                        color: #fff;
                    }
                    & ul {
                        position: absolute;
                        left: 0;
                        top: 25px;
                        background: #fff;
                        width: 470px;
                        z-index: 5;
                        overflow: auto;
                        max-height: 275px;
                        &::-webkit-scrollbar {
                            width: 6px;
                            background: #c4c4c4;
                            border-radius: 0;
                        }
                        &::-webkit-scrollbar-thumb {
                            border-radius: 0;
                        }
                        li {
                            padding: 10px 20px;
                            border-bottom: 1px solid #c4c4c4;
                            font-size: 15px;
                            line-height: 192.19%;
                            color: #585858;
                            &:last-of-type {
                                border: none;
                            }
                        }
                    }
                    & > button,
                    & > a,
                    & span a {
                        &:hover {
                            opacity: 0.8;
                        }
                    }
                    & > span a {
                        position: relative;
                        &:before {
                            content: "";
                            position: absolute;
                            right: -25px;
                            top: 50%;
                            width: 15px;
                            height: 2px;
                            transform: translateY(-50%);
                        }
                        &:after {
                            content: "";
                            position: absolute;
                            right: -25px;
                            top: 50%;
                            width: 10px;
                            height: 10px;
                            transform: translateY(-50%) rotate(-45deg);
                            border-right: 2px solid;
                            border-bottom: 2px solid;
                        }
                    }
                    &.STO__options {
                        @media screen and (max-width: 767px) {
                            display: none;
                        }
                    }
                    &.STO__contacts,
                    &.STO__work-time {
                        @media screen and (max-width: 767px) {
                            width: 100%;
                            align-items: flex-start;
                        }
                    }
                    &.STO__map-button {
                        display: none;
                        @media screen and (max-width: 767px) {
                            display: block;
                        }
                    }
                }
            }
        }
        #map {
            @media screen and (max-width: 1200px) {
                width: 100%;
                height: 300px;
            }
            @media screen and (max-width: 767px) {
                display: block;
                &.hideMap {
                    display: none;
                }
            }
        }
    }
}
.shate {
    .mapVue-wrapper {
        .wrap {
            & > button {
                border-color: #ed0b0e !important;
                color: #ed0b0e;
            }
        }
    }
    .vue-treeselect {
        border-left-color: #ed0b0e !important;
    }
    .result-block {
        .STO {
            &__info {
                & > li {
                    & > span,
                    & > button,
                    & > span a {
                        color: #ed0b0e;
                    }
                    & > button {
                        &:before {
                            border-right-color: #ed0b0e;
                            border-bottom-color: #ed0b0e;
                        }
                    }
                    & ul {
                        &::-webkit-scrollbar-thumb {
                            background: #ed0b0e;
                        }
                    }
                    & > span a {
                        position: relative;
                        &:before {
                            background: #ed0b0e;
                        }
                        &:after {
                            border-right-color: #ed0b0e;
                            border-bottom-color: #ed0b0e;
                        }
                    }
                }
            }
        }
    }
    .stations-list{
        &::-webkit-scrollbar-thumb {
            background: #ed0b0e;
        }
    }
    .list-wrapper{
        ul{
            li{
                label{
                    input:checked + span{
                        svg{
                            path{
                                stroke: #ed0b0e;
                            }
                        }
                    }
                }
            }
        }
    }
}
.euro {
    .mapVue-wrapper {
        .wrap {
            & > button {
                border-color: #005395 !important;
                color: #005395;
            }
        }
    }
    .vue-treeselect {
        border-left-color: #005395 !important;
    }
    .result-block {
        .STO {
            &__info {
                & > li {
                    & > span,
                    & > button,
                    & > span a {
                        color: #005395;
                    }
                    & > button {
                        &:before {
                            border-right-color: #005395;
                            border-bottom-color: #005395;
                        }
                    }
                    & ul {
                        &::-webkit-scrollbar-thumb {
                            background: #005395;
                        }
                    }
                    & > span a {
                        position: relative;
                        &:before {
                            background: #005395;
                        }
                        &:after {
                            border-right-color: #005395;
                            border-bottom-color: #005395;
                        }
                    }
                }
            }
        }
    }
    .stations-list{
        &::-webkit-scrollbar-thumb {
            background: #005395;
        }
    }
    .list-wrapper{
        ul{
            li{
                label{
                    input:checked + span{
                        svg{
                            path{
                                stroke: #005395;
                            }
                        }
                    }
                }
            }
        }
    }
}
.patron {
    .mapVue-wrapper {
        .wrap {
            & > button {
                border-color: #ed0b0e !important;
                color: #ed0b0e;
            }
        }
    }
    .vue-treeselect {
        border-left-color: #ed0b0e !important;
    }
    .result-block {
        .STO {
            &__info {
                & > li {
                    & > span,
                    & > button,
                    & > span a {
                        color: #ed0b0e;
                    }
                    & > button {
                        &:before {
                            border-right-color: #ed0b0e;
                            border-bottom-color: #ed0b0e;
                        }
                    }
                    & ul {
                        &::-webkit-scrollbar-thumb {
                            background: #ed0b0e;
                        }
                    }
                    & > span a {
                        position: relative;
                        &:before {
                            background: #ed0b0e;
                        }
                        &:after {
                            border-right-color: #ed0b0e;
                            border-bottom-color: #ed0b0e;
                        }
                    }
                }
            }
        }
    }
    .stations-list{
        &::-webkit-scrollbar-thumb {
            background: #ed0b0e;
        }
    }
    .list-wrapper{
        ul{
            li{
                label{
                    input:checked + span{
                        svg{
                            path{
                                stroke: #ed0b0e;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>